import script from "./BaseActionMenuButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseActionMenuButton.vue?vue&type=script&setup=true&lang=ts"

import "./BaseActionMenuButton.vue?vue&type=style&index=0&id=1ee1f772&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee1f772"]])

export default __exports__